"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CustomLink_1 = __importDefault(require("./CustomLink"));
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        textAlign: 'center',
    }
}); });
var LinkItem = function (_a) {
    var link = _a.link, title = _a.title, isTargetBlank = _a.isTargetBlank, onClick = _a.onClick, isDisplay = _a.isDisplay;
    var classes = useStyles();
    if (!isDisplay) {
        return null;
    }
    return (react_1.default.createElement(CustomLink_1.default, { href: link, isTargetBlank: !!isTargetBlank },
        react_1.default.createElement(core_1.MenuItem, { className: classes.root, onClick: onClick },
            react_1.default.createElement(core_1.ListItemText, { primary: title }))));
};
exports.default = LinkItem;
